import React from "react";
import Loader from "components/Loader";
import Top from "components/Top";
import * as API from "lib/apis";
import * as C from "../../constants";

import { MyMoneyList, TradeHistory, QuoteChart, Footer } from "pages";

import { actionAppCengold, finishAlert, webviewFinish } from "lib/utils";
import { useLocalStorage } from "../../lib/useLocalStorage";

const queryString = require("query-string");

class Main extends React.Component {
  state = {
    currentPoint: 0,
    info: {},
    profit: {},
    balance: {},
    currentPrice: {},
    priceTrend: {},
    histories: {},
    isLoading: false,
  };

  constructor(props) {
    super(props);

    this.queryObj = queryString.parse(props.location.search);
    this.name = this.queryObj["name"];
    this.display = C.Message.display[props.serviceCode];
    this.actionAppCengold = actionAppCengold.bind(this);
    this.webviewFinish = webviewFinish.bind(this);
    this.closeWebview = this.closeWebview.bind(this);
    window.mainComp = this;
  }

  closeWebview() {
    finishAlert("mainComp.webviewFinish");
  }

  componentDidMount = () => {
    if (this.props.serviceCode === C.SERVICE_CODE.SYRUP) {
      window.wallet.setPageConfig(
        '{"pageType":"MEMBERSHIP", "backJS":"mainComp.closeWebview"}'
      );
      window.wallet.setTitle('{"title":"비단 금투자 서비스"}');
    }
  };

  componentWillMount = () => {
    this.setState({ isLoading: true });
    const apiInfo = API.getInfo(({ data }) => {
      this.setState((state) => ({
        ...state,
        info: data,
      }));
    });
    const apiPrice = API.getCurrentPrice(({ data }) => {
      this.setState((state) => ({
        ...state,
        currentPrice: data,
      }));
    });
    const apiPriceTrend = API.getPriceTrend(({ data }) => {
      this.setState((state) => ({
        ...state,
        priceTrend: data,
      }));
    });
    const apiHistories = API.getHistories(({ data }) => {
      this.setState((state) => ({
        ...state,
        histories: data,
      }));
    });

    Promise.all([apiInfo, apiHistories, apiPrice, apiPriceTrend]).then(() => {
      this.setState({ isLoading: false });
    });
  };

  handleBackButton = () => this.props.history.goBack();

  render() {
    const { serviceCode } = this.props;

    const { currentPrice, histories, isLoading } = this.state;
    // const { ocbPoint, profit, balance } = this.state.info;
    const { ocbPoint = 0, profit = 0, balance = 0 } = this.state.info || {};
    return (
      <>
        {isLoading && <Loader />}
        {/* <Top history={ this.props.history }/> */}
        <div
          className={`wrap ${
            serviceCode === C.SERVICE_CODE.MONEYTREE
              ? "moneytree_wrap"
              : serviceCode === C.SERVICE_CODE.OKINV
              ? "ok_wrap"
              : ""
          }`}
        >
          <MyMoneyList
            name={this.name}
            profit={profit}
            balance={balance}
            ocbPoint={ocbPoint}
            currentPrice={currentPrice}
            handleClickBuyMove={(type) => {
              this.props.history.push({
                pathname: "/buy",
                search: `?type=${type}&name=${this.name}&serviceCode=${serviceCode}`,
              });
            }}
          />
          <TradeHistory histories={histories} />
          <div className="par_line"></div>
          <QuoteChart chartData={this.state.priceTrend} />
          <Footer />
        </div>
      </>
    );
  }
}

function withStorage(Component) {
  return function WrappedComponent(props) {
    const [serviceCode] = useLocalStorage(C.STORAGE_KEY.SERVICE_CODE, "");
    return <Component {...props} serviceCode={serviceCode} />;
  };
}

export default withStorage(Main);
